import {createFileRoute} from '@tanstack/react-router';
import React from 'react';
import {QuizResponsesPage} from './quiz-responses';

/**
 * Master → ScorePal Quiz: the /scorepal-quiz/ answers on their own page — how organisers collect
 * money, what would save them time, how they'd pay, how a $19.99 pass for 16 lands and what would
 * stop them — charted per question, with every response below. The Quiz Responses page, fixed to
 * the pricing funnel.
 */
export const Route = createFileRoute('/_app/master/scorepal-quiz')({
    component: () => <QuizResponsesPage locked="pricing" title="ScorePal Quiz" />,
});
